// FAQ Search
class FAQSearch {
  constructor() {
    this.searchInput = document.querySelector('#FAQSearchTerm');
    this.faqItems = document.querySelectorAll('.accordions-section .accordion__item');
    this.clearBtn = document.querySelector('.section-faq-search .btn--clear');

    this.faqData = [];

    this.init();
  }

  init() {
    this.indexFAQs();
    this.bindEvents();
  }

  indexFAQs() {
    this.faqData = Array.from(this.faqItems).map((item, idx) => ({
      id: item.id,
      element: item,
      question: item.querySelector('.accordion__title-text')?.textContent.toLowerCase() || '',
      answer: item.querySelector('.accordion__text')?.textContent.toLowerCase() || '',
      button: item.querySelector('button.accordion__title'),
      searchableText: '',
      styleDisplay: '',
      visible: true
    }))

    this.faqData.forEach(faq => {
      faq.searchableText = `${faq.question} ${faq.answer}`.toLowerCase();
      faq.styleDisplay = window.getComputedStyle(faq.element).display;
    });
  }

  collapseFAQ(faq) {
    faq.visible = true;
    faq.element.style.display = faq.styleDisplay || 'block';
    const title = faq.element.querySelector('.accordion__title');
    const textWrapper = faq.element.querySelector('.accordion__text-wrapper');
    title.classList.remove('is-expanded');
    title.setAttribute('aria-expanded', 'false');
    textWrapper.classList.remove('is-expanded');
    textWrapper.style.height = '';
  }

  bindEvents() {
    let searchTimeout;
    this.searchInput.addEventListener('input', (e) => {
      const searchValue = e.target.value.trim();
      
      if (!searchValue) {
        clearTimeout(searchTimeout);
        this.clearHighlights();
        this.showAllFAQs(true);
        return;
      }
      
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        this.performSearch(searchValue);
      }, 150);
    });

    this.clearBtn.addEventListener('click', () => {
      this.clearSearch();
    })
  }

  performSearch(searchTerm) {
    if(!searchTerm) {
      this.showAllFAQs();
      return;
    }
    
    const searchWords = searchTerm
      .toLowerCase()
      .replace(/[^\w\s]/g, '')
      .split(/\s+/)
      .filter(word => word.length > 0);


    this.faqData.forEach(faq => {
      const matchesAll = searchWords.every(word => faq.searchableText.includes(word));

      if(matchesAll) {
        this.showFAQ(faq);
        this.highlightSearchTerms(faq, searchWords);
      } else {
        this.hideFAQ(faq);
      }
    });
  }

  showFAQ(faq) {
    faq.visible = true;
    faq.element.style.display = faq.styleDisplay || 'block';
    const title = faq.element.querySelector('.accordion__title');
    const textWrapper = faq.element.querySelector('.accordion__text-wrapper');
    title.classList.add('is-expanded');
    title.setAttribute('aria-expanded', 'true');
    textWrapper.classList.add('is-expanded');
    textWrapper.style.height = 'auto';
  }

  hideFAQ(faq) {
    faq.visible = false;
    faq.element.style.display = 'none';
  }

  showAllFAQs(shouldCollapse = false) {
    this.faqData.forEach(faq => {
      if (shouldCollapse) {
        this.collapseFAQ(faq);
      } else {
        this.showFAQ(faq);
      }
    });
  }

  clearSearch() {
    this.searchInput.value = '';
    this.clearHighlights();
    this.showAllFAQs(true);
    this.searchInput.focus();
  }

  highlightSearchTerms(faq, searchWords) {
    const question = faq.element.querySelector('.accordion__title-text');
    const answer = faq.element.querySelector('.accordion__text');
    [question, answer].forEach(item => {
      if (item) {
        let text = item.textContent;
        searchWords.forEach(word => {
          const regex = new RegExp(word, 'gi');
          text = text.replace(regex, `<mark>${word}</mark>`);
        });
        item.innerHTML = text;
      }
    });
  }

  clearHighlights() {
    this.faqData.forEach(faq => {
      const question = faq.element.querySelector('.accordion__title-text');
      const answer = faq.element.querySelector('.accordion__text');
      [question, answer].forEach(item => {
        if (item) {
          const cleanText = item.textContent;
          item.innerHTML = cleanText;
        }
      });
    });
  }

}

document.addEventListener("DOMContentLoaded", function() {
  if (document.querySelector('.section-faq-search')) {
    new FAQSearch();
  }
});
document.addEventListener('shopify:section:load', () => {
  if (document.querySelector('.section-faq-search')) {
    new FAQSearch();
  }
});